import React, { useCallback } from 'react';

import { PetPartnersWelcomeCard } from './PetPartnersWelcomeCard';
import { WelcomeContent } from './WelcomeContent';

import { PET_DEMOS_STEPS } from './petDemographics.constants';
import { Policy } from './myPolicy/Policy';
import { usePetDemographics, usePetDemosSteps } from './hooks';

import styles from './WelcomeScreen.module.css';

const WelcomeScreen = () => {
  const { usePendingDemographicsFF } = usePetDemographics();
  const {
    currentStep,
    goToNextStep,
    initialStep,
  } = usePetDemosSteps();

  if (!usePendingDemographicsFF) {
    return null;
  }

  const renderStepContent = useCallback(() => {
    switch (currentStep) {
      case PET_DEMOS_STEPS.WELCOME:
        return <WelcomeContent goToNextStep={goToNextStep} />;

      case PET_DEMOS_STEPS.YOUR_POLICY:
        return <Policy goToNextStep={goToNextStep} />;

      default:
        return <span>WIP STEP NUMBER: {currentStep + 1}</span>;
    }
  }, [currentStep, goToNextStep]);

  return (
    <div className={styles.mainContainer} data-initial-step={initialStep}>
      <PetPartnersWelcomeCard initialStep={initialStep}>
        {renderStepContent()}
      </PetPartnersWelcomeCard>
    </div>
  );
};

export { WelcomeScreen };
